import { Link } from "react-router-dom";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import { LuScanFace } from "react-icons/lu";
import { MdOutlineLaptopChromebook } from "react-icons/md";
import { FaTv } from "react-icons/fa6";
import { FaUserLarge } from "react-icons/fa6";
import { MdFaceRetouchingNatural } from "react-icons/md";
import { RiMapPinUserLine } from "react-icons/ri";
import { TbUserPin } from "react-icons/tb";
import { HiH3 } from "react-icons/hi2";

const services = [
  {
    // icon: "/hrms-software-dashboard.svg",
    icon: <FaTv size={28} color="#10324F" aria-hidden="true" />,
    title: "HRMS Software",
    desc: "Process salaries, generate payslips, manage deductions, reimbursements, and statutory compliance from one connected payroll platform",
    link: "/hrms-software",
  },
  {
    // icon: "employee-attendance-app.svg",
    icon: <FaUserLarge size={28} color="#10324F" aria-hidden="true" />,
    title: "Staff Management App",
    desc: "Organise employee records, departments, documents, onboarding data, and workforce information with complete visibility",
    link: "/staff-attendance-app",
  },
  {
    // icon: "/face-recognition-attendance-system-system.svg",
    icon: <MdFaceRetouchingNatural size={28} color="#10324F" />,
    title: "Face Recognition Attendance",
    desc: "Track employee attendance with selfie verification and location-supported check-ins no hardware or biometric device needed",
    link: "/face-recognition-attendance-system",
  },
  {
    // icon: " /employee-location-tracking-software-system.webp",
    icon: <TbUserPin size={28} color="#10324F" aria-hidden="true" />,
    title: "Live Location Tracking",
    desc: "Monitor field employees and remote teams in real time with live GPS location visibility and geo-verified attendance",
    link: "/employee-location-tracking-software",
  },
  {
    icon: <LuScanFace size={28} color="#10324F" aria-hidden="true" />,
    title: "Face Lens App",
    desc: "Transform any smartphone into a face recognition attendance system with AI-powered verification, automatic attendance marking, and seamless payroll integration",
    link: "/facelens-app",
  },
];

export default function Services() {
  return (
    <>
      <section
        id="Services"
        className="relative overflow-hidden py-3 mb-10 mt-10"
      >
        {/* ✅ BACKGROUND DOTS (move here) */}
        <div className="pointer-events-none absolute inset-0 flex justify-center ">
          <div className="relative w-full max-w-7xl">
            {/* Top-left big dot */}
            <div className="absolute left-3 sm:left-18 top-38 w-16 h-16 bg-[#1f3b57] rounded-full "></div>
            {/* Left-middle dot */}
            <div className="absolute left-[28%] top-[66%] w-14 h-14 bg-[#1f3b57] rounded-full"></div>
            {/* Center-bottom dot */}
            <div className="absolute left-1/2 bottom-10 w-12 h-12 bg-[#1f3b57] rounded-full -translate-x-1/2 hidden sm:block"></div>
            {/* Top-right dot */}
            <div className="absolute right-[26%] top-48 w-16 h-16 bg-[#1f3b57] rounded-full hidden sm:block"></div>
            {/* Bottom-right dot */}
            <div className="absolute right-16 bottom-0 w-14 h-14 bg-[#1f3b57] rounded-full"></div>
          </div>
        </div>

        <div className="max-w-6xl mx-auto  px-6 text-center">
          <h2 className="text-[#10324F] text-xl sm:text-3xl font-roboto font-bold leading-snug text-center mb-4 uppercase">
            Everything Your Business Needs to Manage Employees
          </h2>
          <p className="section-desc mx-auto max-w-3xl text-center text-[#10234F] mb-10">
            Empower your workforce with our Payroll Web App and Staff Attendance
            App, built for real-time attendance tracking, automated salary
            processing, and seamless payroll management
          </p>
          <div>
            <Swiper
              modules={[Navigation, Autoplay]}
              spaceBetween={20}
              navigation
              autoplay={{ delay: 3000 }}
              breakpoints={{
                0: { slidesPerView: 1 },
                640: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
                1280: { slidesPerView: 4 },
              }}
            >
              {services.map((item, index) => (
                <SwiperSlide key={index} className="h-full">
                  <div
                    className="
                    relative
                    h-full
                    rounded-[14px]
                    px-6 py-9
                    bg-linear-to-b from-white via-[#f7fbff] to-[#eef5fb]
                    border border-[#e6eef6]
                    shadow-[0_12px_30px_rgba(13,59,93,0.12)]
                    transition-all duration-300
                    hover:-translate-y-2
                    hover:shadow-[0_20px_45px_rgba(13,59,93,0.18)]
                     opacity-80
                  "
                  >
                    <span className="pointer-events-none absolute inset-x-0 top-0 h-[40%] rounded-t-[14px] bg-linear-to-b from-white/80 to-transparent" />
                    <div
                      className="
                      relative
                      w-16.25 h-16.5
                      mx-auto mb-6
                      rounded-xl
                      bg-white
                      flex items-center justify-center
                      shadow-[0_6px_20px_rgba(13,59,93,0.15)]
                      p-3.25
                    "
                    >
                      {item.icon}
                      {/* {!item.icon && <MdOutlineLaptopChromebook />} */}
                    </div>

                    {/* Title */}
                    <h2 className="relative text-[#0b3c5d] font-roboto font-semibold text-[17px] leading-none mb-5 w-56">
                      {item.title}
                    </h2>

                    {/* Description */}
                    <p className="relative text-[#10324f] font-roboto font-light text-[12px] leading-[190%] text-center mb-6 h-27.5">
                      {item.desc}
                    </p>

                    {/* Button */}
                    <Link
                      to={item.link}
                      // onClick={() => window.scrollTo(0, 0)}
                      className="
                     relative
    font-roboto font-medium text-[16px]
    text-[#0b3c5d]
    bg-[#f3f8fc]
    border border-white
    px-11.5 py-3.25
    rounded-[5px]
    shadow-[5px_5px_5px_2px_rgba(0,0,0,0.12),0_21px_36px_rgba(0,0,0,0.08)]
    transition-all duration-200
    hover:-translate-y-0.5
    hover:shadow-[0_10px_24px_rgba(0,0,0,0.16),0_4px_8px_rgba(0,0,0,0.1)]
    active:translate-y-0
    active:shadow-[0_4px_10px_rgba(0,0,0,0.12)]
    max-[1187px]:text-[14px]
    max-[1187px]:px-9.75
                    "
                    >
                      View Details
                    </Link>
                  </div>
                  {/* END CARD */}
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </section>
    </>
  );
}
